import { OssConfig } from '../../config'
import { ImgKey } from '../media/img-key'

export class Receipt extends ImgKey {

  procure_receipt_id: number
  batch_id: number
  name: string

  constructor(data: any = {}) {
    super(OssConfig.receipt, data.name)
    this.procure_receipt_id = data.procure_receipt_id
    this.batch_id = data.batch_id
    this.name = data.name
  }

  get full_file_key(): string {
    return this.img_url
  }

}



// WEBPACK FOOTER //
// ./src/app/models/batch/receipt.ts